import { render, staticRenderFns } from "./TestingTemplateEditor.vue?vue&type=template&id=348cafd5&scoped=true"
import script from "./TestingTemplateEditor.vue?vue&type=script&lang=js"
export * from "./TestingTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./TestingTemplateEditor.vue?vue&type=style&index=0&id=348cafd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348cafd5",
  null
  
)

export default component.exports